import { useHotpayKwota } from '../hooks/useHotpayKwota'
import type { PassTier } from '../data/placesIndex'

type LaunchPromoPriceProps = {
  tone?: 'default' | 'onDark'
  className?: string
  tier?: PassTier
}

/** Cena z Cloudflare: Mini i Full po 19 zł. */
export function LaunchPromoPrice({
  tone = 'default',
  className = '',
  tier = 'full',
}: LaunchPromoPriceProps) {
  const { label, regularLabel, promoActive, loading, error } = useHotpayKwota(tier)

  if (loading && !label) {
    return (
      <span className={className} aria-busy="true">
        …
      </span>
    )
  }

  if (!label) {
    return (
      <span className={className} title={error ?? undefined}>
        —
      </span>
    )
  }

  if (!promoActive) {
    return <span className={className}>{label}</span>
  }

  const strikeClass =
    tone === 'onDark'
      ? 'line-through decoration-paper/60 opacity-80'
      : 'line-through decoration-ink/50'
  const arrowClass = tone === 'onDark' ? 'opacity-70' : 'opacity-60'
  const promoClass = tone === 'onDark' ? 'font-extrabold' : 'font-extrabold text-ink'

  return (
    <span className={['inline-flex flex-wrap items-center gap-x-2 gap-y-0.5', className].join(' ')}>
      <span className={strikeClass}>{regularLabel}</span>
      <span className={arrowClass} aria-hidden>
        →
      </span>
      <span className={promoClass}>{label}</span>
    </span>
  )
}
